/* ============================================================
   BioActive+ Premium Cart — Dawn drop-in behaviour
   assets/bioactive-cart.js
   Pure vanilla JS, no dependencies. Enhances the server-rendered
   Liquid with AJAX cart updates + a slide-in drawer.
   Drawer opens OPTIMISTICALLY (instantly on click); fresh section
   HTML swaps in when the network response lands.
   ============================================================ */
(function () {
  'use strict';
  if (window.__bacInit) return; window.__bacInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION_DRAWER = 'bioactive-cart-drawer';
  var SECTION_PAGE = 'bioactive-cart';

  function qs(sel, el) { return (el || document).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  /* which sections exist on this page (so we only re-render what's here).
     The page cart section (.bac) is only re-rendered on the cart page itself —
     on other pages a matching element may be a sticky bar near the footer, and
     rewriting it on every cart change makes the browser re-anchor its scroll
     position around the footer (the "page jumps to footer" bug). */
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }
  function activeSections() {
    var list = [];
    if (qs('[data-bac-drawer-host]')) list.push(SECTION_DRAWER);
    if (onCartPage()) {
      var page = qs('.bac[data-section-id]');
      if (page) list.push(page.getAttribute('data-section-id'));
    }
    return list;
  }

  /* POST a cart mutation, requesting fresh section HTML back */
  function cartFetch(endpoint, body) {
    body.sections = activeSections().join(',');
    body.sections_url = window.location.pathname;
    return fetch(ROOT + 'cart/' + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* swap in re-rendered sections */
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (name) {
      var tmp = document.createElement('div');
      tmp.innerHTML = sections[name];
      if (name === SECTION_DRAWER) {
        var fresh = qs('[data-bac-drawer-content]', tmp);
        var cur = qs('[data-bac-drawer-content]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      } else if (onCartPage()) {
        var freshP = qs('.bac', tmp);
        var curP = qs('.bac[data-section-id]');
        if (freshP && curP) curP.innerHTML = freshP.innerHTML;
      }
    });
    updateThemeCount();
  }
  /* expose for PDP scripts */
  window.__bacApplySections = applySections;

  /* keep the theme's own cart bubble in sync */
  function updateThemeCount() {
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      qsa('.cart-count-bubble span[aria-hidden], .cart-count-bubble span:first-child').forEach(function (el) { el.textContent = c.item_count; });
      qsa('[data-bac-headcount]').forEach(function (el) { el.textContent = '(' + c.item_count + ')'; });
      qsa('[data-bac-headcount-bubble]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); });
      /* update BioActive custom header bag count */
      qsa('.ba-bag-count').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  }

  function busy(on) { document.documentElement.classList.toggle('bac-busy', !!on); }

  /* ---------- toast + money helpers ---------- */
  function bacFormatAmount(cents, currency) {
    var n = (cents || 0) / 100;
    var s = n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return currency ? (s + ' ' + currency) : s;
  }
  function bacToast(type, title, msg) {
    var wrap = document.getElementById('bac-toasts');
    if (!wrap) { wrap = document.createElement('div'); wrap.id = 'bac-toasts'; document.body.appendChild(wrap); }
    var el = document.createElement('div');
    el.className = 'bac-toast bac-toast--' + type;
    var ic = document.createElement('span'); ic.className = 'bac-toast-ic';
    ic.innerHTML = type === 'success'
      ? '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'
      : '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16.6v.01"/></svg>';
    var tx = document.createElement('span'); tx.className = 'bac-toast-tx';
    var b = document.createElement('b'); b.textContent = title; tx.appendChild(b);
    if (msg) { var sp = document.createElement('span'); sp.textContent = msg; tx.appendChild(sp); }
    el.appendChild(ic); el.appendChild(tx);
    wrap.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    var tm = setTimeout(dismiss, 2200);
    function dismiss() { clearTimeout(tm); el.classList.add('is-out'); setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 340); }
    el.addEventListener('click', dismiss);
  }
  window.__bacToast = bacToast;

  /* ---------- mutations ---------- */
  function changeLine(key, quantity) {
    busy(true);
    return cartFetch('change.js', { id: key, quantity: quantity }).then(function (res) {
      applySections(res.sections); busy(false); return res;
    }).catch(function () { busy(false); });
  }

  // switch one-time <-> subscription (and frequency) = remove + re-add with selling_plan
  function setSellingPlan(item, planId) {
    var key = item.getAttribute('data-line-key');
    var variant = item.getAttribute('data-variant');
    var qty = parseInt(item.getAttribute('data-qty'), 10) || 1;
    busy(true);
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () {
      var line = { id: parseInt(variant, 10), quantity: qty };
      if (planId) line.selling_plan = parseInt(planId, 10);
      return cartFetch('add.js', { items: [line] });
    }).then(function (res) { applySections(res.sections); busy(false); })
      .catch(function () { busy(false); });
  }

  function addVariant(variantId, open) {
    busy(true);
    if (open) openDrawer(); /* optimistic — open instantly, content swaps in on response */
    return cartFetch('add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      .then(function (res) { applySections(res.sections); busy(false); return res; })
      .catch(function () { busy(false); });
  }

  /* ---------- drawer open/close ---------- */
  function openDrawer() {
    var host = qs('[data-bac-drawer-host]');
    if (host) {
      host.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('bac-open');
    }
  }
  function closeDrawer() {
    var host = qs('[data-bac-drawer-host]');
    if (host) {
      host.classList.remove('is-open');
      document.body.style.overflow = '';
      document.documentElement.classList.remove('bac-open');
    }
  }

  /* open drawer instantly, refresh cart section HTML in the background */
  function refreshAndOpen() {
    openDrawer(); /* optimistic — was: open only after cart/update.js round-trip */
    var sects = activeSections();
    if (!sects.length) { updateThemeCount(); return; }
    busy(true);
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: {}, sections: sects.join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.sections) applySections(res.sections);
        else updateThemeCount();
        busy(false);
      })
      .catch(function () { updateThemeCount(); busy(false); });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var openBtn = t.closest('[data-bac-open]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }

    if (t.closest('[data-bac-close]')) { e.preventDefault(); closeDrawer(); return; }

    var qBtn = t.closest('[data-bac-qty]');
    if (qBtn) {
      e.preventDefault();
      var item = qBtn.closest('[data-bac-item]');
      var delta = parseInt(qBtn.getAttribute('data-bac-qty'), 10);
      var q = (parseInt(item.getAttribute('data-qty'), 10) || 1) + delta;
      changeLine(item.getAttribute('data-line-key'), Math.max(0, q));
      return;
    }

    var rm = t.closest('[data-bac-remove]');
    if (rm) {
      e.preventDefault();
      var it = rm.closest('[data-bac-item]');
      changeLine(it.getAttribute('data-line-key'), 0);
      return;
    }

    var planBtn = t.closest('[data-bac-plan]');
    if (planBtn) {
      e.preventDefault();
      var itp = planBtn.closest('[data-bac-item]');
      setSellingPlan(itp, planBtn.getAttribute('data-bac-plan'));
      return;
    }

    var add = t.closest('[data-bac-add]');
    if (add && !add.disabled) { e.preventDefault(); addVariant(add.getAttribute('data-bac-add'), true); return; }

    var dt = t.closest('[data-bac-disc-toggle]');
    if (dt) {
      dt.classList.toggle('is-open');
      var wrap = qs('[data-bac-disc-wrap]', dt.parentNode);
      if (wrap) wrap.classList.toggle('is-open');
      var dw0 = dt.closest('[data-bac-discount]');
      var er0 = dw0 && qs('[data-bac-code-error]', dw0);
      if (er0) er0.classList.add('bac-hidden');
      var fl0 = dw0 && qs('[data-bac-disc-field]', dw0);
      if (fl0) fl0.classList.remove('bac-shake');
      return;
    }

    var apply = t.closest('[data-bac-apply-code]');
    if (apply) {
      e.preventDefault();
      var discWrap = apply.closest('[data-bac-discount]');
      var input = qs('[data-bac-code-input]', discWrap);
      var errEl = qs('[data-bac-code-error]', discWrap);
      var fieldEl = qs('[data-bac-disc-field]', discWrap) || (input && input.parentNode);
      var code = (input && input.value || '').trim();
      function discErr(msg) {
        if (errEl) { errEl.textContent = msg; errEl.classList.remove('bac-hidden'); }
        if (fieldEl) { fieldEl.classList.remove('bac-shake'); void fieldEl.offsetWidth; fieldEl.classList.add('bac-shake'); }
      }
      if (!code) { discErr('Enter a promo code first.'); if (input) input.focus(); return; }
      if (apply.getAttribute('data-loading') === '1') return;
      var applyLabel = apply.textContent;
      function restore() { apply.removeAttribute('data-loading'); apply.disabled = false; apply.textContent = applyLabel; }
      apply.setAttribute('data-loading', '1'); apply.disabled = true; apply.textContent = 'Applying\u2026';
      if (errEl) errEl.classList.add('bac-hidden');
      busy(true);
      var codeShown = code.toUpperCase();
      var beforeDisc = 0;
      var aborted = false;
      fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (before) {
          /* EMPTY CART — stop before we ask Shopify anything.
             With no lines there is nothing for a discount to be allocated
             against, so cart/update.js reports even a perfectly valid code as
             inapplicable. The failure branch below would then run
             { discount: '' }, which WIPES the code the shopper already had in
             session from an email /discount/CODE link. So: say what to do and
             leave the cart alone. */
          if (!before || !before.item_count) {
            aborted = true;
            busy(false); restore();
            discErr('Add a product to your cart first, then apply your code.');
            bacToast('error', 'Your cart is empty', 'Add a product first, then apply your code.');
            return null;
          }
          beforeDisc = before.total_discount || 0;
          return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) }).then(function (r) { return r.json(); });
        })
        .then(function () { if (aborted) return null; return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          if (aborted || !cart) return;
          var codes = (cart && cart.discount_codes) || [];
          var entry = null;
          for (var i = 0; i < codes.length; i++) { if ((codes[i].code || '').toLowerCase() === code.toLowerCase()) { entry = codes[i]; break; } }
          var delta = ((cart && cart.total_discount) || 0) - beforeDisc;
          var ok = entry ? (entry.applicable !== false) : (delta > 0);
          if (ok) {
            var saved = (entry && entry.amount) ? entry.amount : delta;
            if (input) input.value = '';
            return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: {}, sections: activeSections().join(','), sections_url: window.location.pathname }) })
              .then(function (r) { return r.json(); })
              .then(function (res) { applySections(res.sections); busy(false); restore(); bacToast('success', 'Promo code \u201c' + codeShown + '\u201d applied', saved > 0 ? ('You saved ' + bacFormatAmount(saved, cart.currency)) : ''); });
          }
          fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: '' }) }).catch(function () {});
          busy(false); restore();
          discErr('\u201c' + codeShown + '\u201d isn\u2019t valid or doesn\u2019t apply to your cart.');
          bacToast('error', 'Couldn\u2019t apply \u201c' + codeShown + '\u201d', 'Double-check the code and try again.');
        })
        .catch(function () { if (aborted) return; busy(false); restore(); discErr('Something went wrong — please try again.'); bacToast('error', 'Something went wrong', 'Please try again in a moment.'); });
      return;
    }

    var rmCode = t.closest('[data-bac-remove-code]');
    if (rmCode) {
      busy(true);
      fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '', sections: activeSections().join(','), sections_url: window.location.pathname })
      }).then(function(r) { return r.json(); })
        .then(function(res) { applySections(res.sections); busy(false); })
        .catch(function() { busy(false); });
      return;
    }

    var prev = t.closest('[data-bac-rail-prev]');
    var next = t.closest('[data-bac-rail-next]');
    if (prev || next) {
      var rail = qs('[data-bac-rail]', (prev || next).closest('[data-bac-upsell]'));
      if (rail) rail.scrollBy({ left: (next ? 1 : -1) * 262, behavior: 'smooth' });
      return;
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* Clear the promo error the moment the shopper edits or clears the code field */
  document.addEventListener('input', function (e) {
    var ci = e.target && e.target.closest && e.target.closest('[data-bac-code-input]');
    if (!ci) return;
    var dw = ci.closest('[data-bac-discount]');
    var er = dw && qs('[data-bac-code-error]', dw);
    if (er) er.classList.add('bac-hidden');
    var fl = dw && qs('[data-bac-disc-field]', dw);
    if (fl) fl.classList.remove('bac-shake');
  });

  /* listen for PDP add-to-cart — open instantly, refresh content in background */
  document.addEventListener('ba:cart:open', function () { refreshAndOpen(); });

  /* expose openDrawer / closeDrawer globally for PDP scripts */
  window.__bacOpenDrawer = openDrawer;
  window.__bacCloseDrawer = closeDrawer;

  /* open drawer from the theme's cart icon/link instead of navigating to /cart */
  document.addEventListener('click', function (e) {
    if (window.__BAC_NO_OPEN_INTERCEPT) return;
    var link = e.target.closest('a.ba-iconbtn[aria-label="Cart"], a#cart-icon-bubble, a[href$="/cart"], #cart-icon-bubble');
    if (link && qs('[data-bac-drawer-host]')) { e.preventDefault(); openDrawer(); }
  }, true);

  /* close drawer when clicking outside the panel (clicking the scrim area) */
  document.addEventListener('click', function (e) {
    var host = qs('[data-bac-drawer-host]');
    if (!host || !host.classList.contains('is-open')) return;
    var panel = qs('.bac-drawer-panel', host);
    if (e.target === host || (panel && !panel.contains(e.target) && host.contains(e.target))) {
      closeDrawer();
    }
  });

  /* NOTE: The form submit interceptor is intentionally disabled for PDP pages.
     PDP scripts handle their own /cart/add.js with sections parameter.
     This interceptor only runs if __BAC_NO_ADD_INTERCEPT is NOT set AND
     the page has a drawer host AND the form is a native Shopify product form. */
  document.addEventListener('submit', function (e) {
    if (window.__BAC_NO_ADD_INTERCEPT) return;
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!qs('[data-bac-drawer-host]')) return;
    /* skip if any PDP script is handling it (data-ba-form, data-asta-form, data-mag-form, etc.) */
    var hasPdpAttr = Array.prototype.some.call(form.attributes, function (a) { return /^data-.+-form$/.test(a.name); });
    if (hasPdpAttr) return;
    e.preventDefault();
    var fd = new FormData(form);
    fd.append('sections', activeSections().join(','));
    fd.append('sections_url', window.location.pathname);
    busy(true);
    openDrawer(); /* optimistic */
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) { applySections(res.sections); busy(false); })
      .catch(function () { busy(false); });
  }, true);
})();

/* ============================================================
   DRAWER SYNC — added separately from the block above, which is
   untouched original code.

   The drawer section is server-rendered once, at page load. PDP sticky
   bars and buy boxes add over AJAX and render the drawer from the
   `sections` markup returned WITH their cart/add.js call — markup
   Shopify sometimes renders from the cart as it stood BEFORE the add.
   The line then reached the mini-cart count and the checkout but never
   the panel, and closing/reopening did not help because opening only
   toggles a class. A page reload was the only fix.

   This does what the reload did: after any cart mutation, re-request
   that one section for the CURRENT url and swap its contents in. It
   runs last, so it corrects whatever a PDP script rendered first.
   Literal commas in the parameter (an encoded comma returns nothing),
   the query string is preserved for theme previews, and markup is only
   swapped in when non-empty — a failed response can never blank the
   drawer.
   ============================================================ */
(function () {
  'use strict';
  if (window.__bacSyncInit) return; window.__bacSyncInit = true;

  var SECTION = 'bioactive-cart-drawer';
  var CART_RE = /\/cart\/(add|change|update|clear)/i;

  function sectionUrl() {
    var search = window.location.search || '';
    return window.location.pathname + search + (search ? '&' : '?') + 'sections=' + SECTION;
  }

  function sync() {
    if (!document.querySelector('[data-bac-drawer-host]')) return Promise.resolve(false);
    return fetch(sectionUrl(), {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var html = data && data[SECTION];
        if (typeof html !== 'string' || !html.trim()) return false;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-bac-drawer-content]');
        var cur = document.querySelector('[data-bac-drawer-content]');
        if (!fresh || !cur || !fresh.innerHTML.trim()) return false;
        cur.innerHTML = fresh.innerHTML;
        return true;
      })
      .catch(function () { return false; });
  }
  window.__bacSyncDrawer = sync;

  var timer;
  function syncSoon(delay) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      sync().then(function () { setTimeout(sync, 900); });
    }, delay || 220);
  }

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = '';
      try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
      var isCart = CART_RE.test(url);
      var p = _fetch.apply(this, arguments);
      if (isCart) { try { p.then(function () { syncSoon(220); }); } catch (e) {} }
      return p;
    };
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { if (CART_RE.test(String(url))) { this.addEventListener('load', function () { syncSoon(220); }); } } catch (e) {}
      return _open.apply(this, arguments);
    };
  }

  /* Opening the drawer from anywhere re-syncs it, so an add made while it was
     closed is never missed. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-bac-open], .sb-cart, a.ba-iconbtn[aria-label="Cart"], #cart-icon-bubble, a[href$="/cart"]')) syncSoon(120);
  }, true);

  ['ba:cart:open', 'ba:cart:added', 'cart:refresh', 'cart:updated', 'sb:cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () { syncSoon(220); });
  });
})();
